import * as common from '@/store/common/mutation-types';

export const SEARCH_PARAM = 'SEARCH_PARAM';
export const SELECTED_ROW = 'SELECTED_ROW';
export const GROUPS = `GROUPS`;
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';
export const POPUP_PARAMS = 'POPUP_PARAMS';

export default {
	...common,
	SEARCH_PARAM,
	GROUPS,
	SELECTED_ROW,
	DEFAULT_ASSIGN,
	POPUP_PARAMS
};
